export default {
  login: {url: '/admin/site/login', method: 'post'}, // 登录
  restPassword:{url:'/admin/site/reset_password',method:'post'},//充值密码
  //员工管理
  addEmployee:{url:'/admin/employee/add',method:'post'},//添加员工
  editEmployee:{url:'/admin/employee/update',method:'post'},//编辑员工
  deleteEmployee:{url:'/admin/employee/delete',method:"post"},//删除员工
  employeeList:{url:'/admin/employee/list',method:"get"},//员工列表
  selectEmployee:{url:'/admin/employee/options',method:'get'},//员工下拉列表

  //职务管理
  postList:{url:'/admin/post/list',method:'get'},//获取职务列表
  addPost:{url:'/admin/post/add',method:'post'},//创建职务
  editPost:{url:'/admin/post/update',method:'post'},//编辑职务
  deletePost:{url:'/admin/post/delete',method:"post"},//删除职务
  selectPostAndAttribute:{url:'/admin/post/options',method:'get'},//获取职务列表

  //部门管理
  addDepartment:{url:'/admin/department/add',method:'post'},//创建部门
  editDepartment:{url:'/admin/department/update',method:'post'},//编辑部门
  departmentList:{url:'/admin/department/list',method:'get'},//部门列表
  deleteDepartment:{url:'/admin/department/delete',method:'post'},//删除部门

  //会议管理
  meetingList:{url:'/admin/meeting/list',method:'get'},//会议列表
  createMeetingFast:{url:'/admin/meeting/generate',method:'post'},//一键生成
  meetingDetail:{url:'/admin/meeting/detail',method:'get'},//会议详情
  finishMeeting:{url:'/admin/meeting/finish',method:'post'},//结束会议
  getLeaderSummary:{url:'/admin/meeting/leader_rated_summary',method:'get'},//局领导干部测评
  getDeptSummary:{url:'/admin/meeting/dept_rated_summary',method:"get"},//领导班子测评
  getLeaderVoted:{url:"/admin/meeting/political_quality_voted_summary",method:'get'},//获取政治素质投票
  getPromotedData:{url:"/admin/meeting/promote_dept_employee_summary",method:'get'},//获取提拔干部数据

  //提拔人员列表
  getPromotedList:{url:'/admin/promote/list',method:"get"},//获取提拔人员列表
  addPromotedPeople:{url:'/admin/promote/add',method:'post'},//添加提拔人员、
  deletePromotedPeople:{url:'/admin/promote/delete',method:'post'},//删除

}
